import store from "../../state/store";

export const { varsomeHost } = store.getState();

export const varsomePremiumUrl = `${
  store.getState().varsomeHost
}/varsome-editions/varsome-premium`;

export const varsomeClinicalUrl = `${
  store.getState().varsomeHost
}/varsome-editions/varsome-clinical`;

export const recentActivitiesUrl = `${
  store.getState().apiUrl
}/recent_activity/?separate=1`;

export const remoteAuthUserUrl = `${store.getState().ssoUrl}/remote/auth/user/`;

export const apiUrl = `${store.getState().apiUrl}`;

export const varsomeHostUrl = `${store.getState().varsomeHost}`;
